import { configureStore,combineReducers } from '@reduxjs/toolkit'
import appSlice from './appSlice';
import { throttle } from 'lodash';
import { loadState, saveState } from './localStorage';
import { setupListeners } from '@reduxjs/toolkit/query'
import { StudiesApi } from '../api/studiesAPI';
import { MessageApi } from '../api/messageAPI';
import configSlice from './configSlice';
import { AppAPI } from '../api/appAPI';
import { AccountAPI } from '../api/accountsAPI';
import { BouncesApi } from '../api/bouncesAPI';

const rootReducer = combineReducers({
    app: appSlice,
    config: configSlice,
    [StudiesApi.reducerPath]: StudiesApi.reducer,
    [MessageApi.reducerPath]: MessageApi.reducer,
    [AppAPI.reducerPath]: AppAPI.reducer,
    [AccountAPI.reducerPath]: AccountAPI.reducer,
    [BouncesApi.reducerPath]: BouncesApi.reducer,
});

export const store = configureStore({
    reducer: rootReducer,
    preloadedState: loadState(),
});

const saveHandler = throttle(() => {
    console.log('save state');
    saveState(store.getState());
}, 2000);

store.subscribe(saveHandler);

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof rootReducer>

export type AppDispatch = typeof store.dispatch